import * as React from 'react';
import '../../App.css';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import { Grid, createTheme, responsiveFontSizes} from '@mui/material';

import { ThemeProvider } from '@emotion/react';

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

function Copyright() {
  return (
    <ThemeProvider theme={theme}>
      <Typography variant="body1" sx={{color: "#F8F9FA"}}>
        {'© '}
        {new Date().getFullYear()}
        {' DCS UP Diliman'}
      </Typography>
    </ThemeProvider>
  );
}

export default function StickyFooter() {

  const boxStyle = { py: 5, px: 5, mt: 'auto', bgcolor: "#7B1013", flexGrow: 1, width: 1 };
  const linkStyle = { ":hover": {color:"F8F9FA"}, color: "#E6D1D1" };
  const noStyle = { textDecoration: 'none' };
  const spaceStyle = { xs: 1, sm: 2, md: 4 };

  return (
    <ThemeProvider theme={theme}>
      <Box component="footer" sx={boxStyle}>
        <Container maxWidth={1}>
          <Grid item container direction={{ xs: 'column', sm: 'row' }} spacing={spaceStyle} marginTop={3}>

            {/* DCS ADDRESS LEFT */}
            <Grid item xs={6} alignContent="left" spacing={spaceStyle}>

              {/* DCS HEADER */}
              <Typography variant="h4" fontSize={28} sx ={{color: "white", fontWeight: 40, fontSize: "2rem"}}>
                <b>Department of Computer Science</b>
              </Typography>

              {/* ADDRESS */}
              <Typography variant="body1" sx={{color: "white", fontSize: "1rem"}}>
                <br/>
                Alumni Engineers Centennial Hall<br/>
                P. Velasquez St., University of the Philippines <br/>
                Diliman, Quezon City<br/>
                (02) 8981 8500 loc. 3231 | <Link href="mailto: info@dcs.upd.edu.ph" style={noStyle} sx={linkStyle}>info@dcs.upd.edu.ph</Link>
              </Typography>
            </Grid>

            {/* QUICK LINKS RIGHT */}
            <Grid item xs={6} alignContent="left" spacing={spaceStyle}>

              {/* HEADER */}
              <Typography variant="h6" sx={{color: "white", marginBottom: 1}}>
                <b>QUICK LINKS</b><br/>
              </Typography>

              {/* LIST OF LINKS */}
              <Typography sx={{color: "white", marginBottom: 1, fontSize: "1rem"}}>
                <Link href="https://up.edu.ph/" style={noStyle} sx={linkStyle}>University of the Philippines System</Link><br/>
                <Link href="https://upd.edu.ph/" style={noStyle} sx={linkStyle}>University of the Philippines Diliman</Link><br/>
                <Link href="https://coe.upd.edu.ph//" style={noStyle} sx={linkStyle}>UPD College of Engineering</Link><br/>
                <Link href="https://mail.upd.edu.ph/" style={noStyle} sx={linkStyle}>UPD Webmail</Link><br/>
                <Link href="https://crs.upd.edu.ph/" style={noStyle} sx={linkStyle}>UPD Computerized Registration System</Link><br/>
              </Typography>
            </Grid>

          </Grid>

          {/* COPYRIGHT LINE */}
          <Typography align="center" marginTop={3}><Copyright /></Typography>

        </Container>
      </Box>
    </ThemeProvider>
  );
}